import { ObjectPrice } from '../../types/ObjectTypes';
import { VStack } from '@chakra-ui/react';
import { Flex, Text } from '@chakra-ui/layout';
import React, { useCallback, useEffect, useState } from 'react';
import { ObjectParams } from '../../types/ParamsTypes';
import { getPriceDetailsText } from '../../services/Objects/priceCtaText';

export interface ObjectDetailsPriceProps {
  prices: ObjectPrice;
  bookingRouteParams: ObjectParams;
}
export const ObjectPriceInformation = (props: ObjectDetailsPriceProps): JSX.Element => {
  const { prices, bookingRouteParams } = props;
  const rentalPrice = prices.RENTAL;
  const totalPrice = prices.COMMON.totalPrice;
  const formattedTotalPrice = new Intl.NumberFormat('de-De', {
    style: 'currency',
    currency: 'EUR',
  }).format(totalPrice);

  return (
    <VStack alignItems={'flex-start'} spacing={0} gridGap={0}>
      <Flex alignItems={'baseline'}>
        <Text color={'gray.500'}>ab</Text>&nbsp;
        <Text fontWeight={'semibold'} fontSize={'4xl'} color={'green.500'}>
          {formattedTotalPrice}
        </Text>
      </Flex>
      <Flex>
      <Text color={'gray.500'}>{getPriceDetailsText(rentalPrice.numberOfDays, bookingRouteParams)}</Text>
      </Flex>
    </VStack>
  );
};
